<template>
    <div class="app flex-row align-items-center">
      <div class="container">
        <b-row class="justify-content-center">
          <b-col md="6" sm="8">
            <b-card no-body class="mx-4">
              <b-card-body class="p-4">
                <b-form>
                  <h1>Esqueci a Senha</h1>
                  <p class="text-muted">Entre com seu nome de usuário pare receber instruções de recuperação da senha.</p>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text><i class="icon-user"></i></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input v-model="email" type="text" class="form-control" placeholder="Usuário / E-mail" autocomplete="email" />
                  </b-input-group>
  
                  <b-input-group class="mb-4">
    
                      <div class="text-danger" v-if="this.errormessage && this.errormessage != ''"><i class="fa fa-exclamation-triangle fa-lg mt-4"></i> {{ this.errormessage }}</div>

                  </b-input-group>

                </b-form>
              </b-card-body>
              <b-card-footer class="p-4">
                <b-row>
                  <b-col cols="6">
                    <b-button block class="btn btn-facebook" @click="backLogin"><span>Voltar</span></b-button>
                    </b-col>
                  <b-col cols="6">
                    <b-button block class="btn btn-twitter" type="button" @click="requestPasswordOnClick" :disabled="waitingResponse"><span>Solicitar Senha</span></b-button>
                  </b-col>
                </b-row>
              </b-card-footer>
            </b-card>
          </b-col>
        </b-row>
      </div>
    </div>
  </template>
  
  <script>
  import Vue from 'vue'
  import axios from "axios";
  const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_ `{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

  /* Toast */
  import VueNotifications from 'vue-notifications'
  import miniToastr from 'mini-toastr'
  
  const toastTypes = {
    success: 'success',
    error: 'error',
    info: 'info',
    warn: 'warn'
  }
  
  miniToastr.init({types: toastTypes})
  
  function toast ({title, message, type, timeout, cb}) {
    return miniToastr[type](message, title, timeout, cb)
  }
  
  const options = {
    success: toast,
    error: toast,
    info: toast,
    warn: toast
  }
  VueNotifications.setPluginOptions(options)
  
  Vue.use(VueNotifications, options)
  /* Toast - End */

  export default {
    name: 'ForgotPassword',
  
    data: function() {
      return {
        waitingResponse: false,
        errormessage: '',
        email: ''
      }
    },

    methods: {
      async requestPassword() {
        var s = this;     
        s.waitingResponse = true

        await axios.post(
          this.$store.state.ws_url + "/user/passwordrecovery", {
              "companyId": s.$store.state.config.companyId,
              "username": s.email,
              "ip": "127.0.0.1"
          }
          ).then(function(resp) {
            console.log(resp)
            s.password = ""
            s.password2 = ""
            s.errormessage = "E-mail de recuperação de senha enviado."
            toast ({
              type: VueNotifications.types.success,
              title: 'Solicitação de Senha',
              message: 'E-mail de recuperação de senha enviado.',
              timeout: 5000
            })
            s.waitingResponse = false
          })
          .catch(function(error) {
            s.errormessage = error.response.data.message ? error.response.data.message : 'Usuário não encontrado. Verifique e tente novamente.'
            toast ({
              type: VueNotifications.types.error,
              title: 'Solicitação de Senha',
              message: error.response.data.message ? error.response.data.message : 'Usuário não encontrado. Verifique e tente novamente.',
              timeout: 5000
            })
            s.waitingResponse = false
              
          });
      },
      requestPasswordOnClick() {
        this.errormessage = '';
        if(this.email != '') {
          this.requestPassword();       
        }
        else {
          this.errormessage = 'Preencha o campo usuário/e-mail e tente novamente.';
        }
        
      },
      backToPortal() {
        this.$router.push({ path: '/dashboard' })
      },
      backLogin() {
        this.$router.push({ path: '/pages/login' })
      }
    }
  }
  </script>
  